import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import { useDiscardConfirmation } from '../ConfirmationModal/useDiscardConfirmation'
import styles from './HelpModal.module.scss'
import DynamicForm from '../../DynamicForm/DynamicForm'
import { getFormConfig } from './HelpModalFormConfig'
import Button from '../../Button/Button'

interface HelpProps {
  onClose: () => void
  isOpen: boolean
}

function HelpModal(props: HelpProps) {
  const { onClose, isOpen } = props
  const { t } = useTranslation()
  const formConfig = getFormConfig(t)
  // Enabled once the user has actually filled the form (DynamicForm reports
  // dirty fields). Starts disabled because the form is empty on open.
  const [isDirty, setIsDirty] = useState(false)

  const { requestClose, discardConfirmation } = useDiscardConfirmation(
    isDirty,
    () => {
      // The form empties when the dialog closes; the flag has to follow it.
      setIsDirty(false)
      onClose()
    }
  )

  return (
    <>
      <Modal isOpen={isOpen} onClose={requestClose} title={t('HELP.TITLE')}>
        <div className={styles.helpContainer}>
          <p className={`body-medium ${styles.helpSubHeader}`}>
            {t('HELP.SUB_TITLE.FIRST_PART')}
            {t('HELP.SUB_TITLE.SECOND_PART')}
            {t('HELP.SUB_TITLE.THIRD_PART')}
            {t('HELP.SUB_TITLE.FOURTH_PART')}
            {t('HELP.SUB_TITLE.FIFTH_PART')}
          </p>
          <div className={styles.helpFormContainer}>
            <DynamicForm setIsDirty={setIsDirty} {...formConfig} />
            <Button
              color="primary"
              label={t('HELP.SEND_MESSAGE')}
              variant="contained"
              type="submit"
              form={formConfig.id}
              disabled={!isDirty}
              maxWidth
            />
          </div>
        </div>
      </Modal>
      {discardConfirmation}
    </>
  )
}

export default HelpModal
